import Spinner from "./Spinner/Spinner.vue";
import IndeterminateLoader from "./Indeterminate/IndeterminateLoader.vue";

export {
    Spinner,
    IndeterminateLoader,
}

export default Spinner
